<template>
  <div class="page">
    <div
      @click="$router.push({
        path: `/device/developer/os`})"
    >
      device_token: developer, os: os
    </div>
    <br>
  </div>
</template>
